<template>
  <el-popover
    v-bind="$attrs"
    v-on="$listeners"
    :ref="`${_uid}-popover`"
  >
    <div
      class="popover-title">
      <slot name="popover-title">
      </slot>
    </div>
    <div
      class="popover-body">
      <slot name="popover-body">
      </slot>
    </div>

    <div class="more-options">
      <slot name="more-options">
      </slot>
    </div>

    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

.item .el-popover__reference span {
  margin: 0;
}

.el-popover.el-popper {
    .popover-title {
      margin: 0;
      padding-bottom: 24px;

      ::v-deep h3 {
        margin: 0;
        font-size: 14px;
      }
    }

    .popover-body {
      display: flex;
      flex-direction: column;

      ::v-deep .elsa-checkbox-group .elsa-checkbox {
        padding-bottom: 8px;
        padding-top: 8px;

        .el-checkbox__label {
          font-weight: 300;
          font-size: 12px;
          color: $light-blue-2;
        }

        &:first-of-type {
          padding-top: 0px;
        }
        &:last-of-type {
          padding-bottom: 0px;
        }
      }
    }

    .more-options {
      padding-top: 24px;
      display: flex;
      flex-direction: row;

      ::v-deep .elsa-button {
        min-height: 24px;
        min-width: 64px;
        padding: 0px;
        margin: 0;

        &:first-of-type {
          margin-right: 16px;
        }

        span {
          padding: 0;
          margin: 12px auto;
          font-size: 12px;
          text-transform: capitalize;
        }
      }
    }
  }
</style>
